
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'customer-portal-app',
  currentProjectVersion: 'static-1.2215',
  depVersions: {
  "customer-portal-app": "static-1.2215",
  "apollo-dlb": "static-3.86",
  "client-types": "static-1.466",
  "data-fetching-client": "static-1.9644",
  "emoji-mart": "static-3.4",
  "enviro": "static-4.428",
  "growth-payments-core": "static-1.25284",
  "head-dlb": "static-1.4938",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.5566",
  "hs-test-utils": "static-1.7986",
  "hub-http": "static-1.6194",
  "hub-http-shared-msw-handlers": "static-1.9887",
  "hubspot-dlb": "static-2.1832",
  "hubspot-prosemirror": "static-1.18157",
  "hubspot-url-utils": "static-1.4049",
  "HubStyleTokens": "static-2.11437",
  "I18n": "static-7.1615",
  "immutable": "static-2.77",
  "jasmine-runner": "static-1.6439",
  "payment-link-components": "static-1.23448",
  "prosemirror": "static-1.13",
  "quartz": "static-1.6988",
  "quartz-core": "static-1.6207",
  "react": "static-7.185",
  "react-colorpicker": "static-2.10182",
  "react-dlb": "static-1.78",
  "react-utils": "static-2.5320",
  "rich-text-lib": "static-1.19776",
  "transmute": "static-2.85",
  "ui-addon-upgrades": "static-9.17943",
  "ui-components-test-utils": "static-1.5575",
  "UIComponents": "static-3.8384",
  "foundations-assets": "static-1.4835",
  "foundations-components": "static-1.7869",
  "foundations-theming": "static-1.4390",
  "foundations-theming-specialty": "static-1.2106",
  "framer-motion": "static-1.71",
  "metrics-js": "static-1.9542",
  "PortalIdParser": "static-2.388",
  "portals-platform-lib": "static-1.852",
  "quartz-config": "static-1.766",
  "quartz-routing": "static-1.418",
  "quick-fetch": "static-1.3892",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-dom": "static-7.85",
  "react-rhumb": "static-1.16641",
  "rpc-client-utils": "static-1.4624",
  "sanitize-text": "static-1.8114",
  "styled-components": "static-2.88",
  "tanstack-table": "static-1.54",
  "ui-addon-draggable": "static-3.4740",
  "ui-addon-react-router-dom": "static-1.9516",
  "usage-tracker": "static-1.7317",
  "usage-tracker-anonymous": "static-1.5734",
  "usage-tracker-core": "static-1.7167",
  "apollo-stack-hubspot": "static-3.84",
  "hs-promise-rejection-tracking": "static-1.5489",
  "raven": "static-3.5829",
  "raven-hubspot": "static-1.6136",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "react-redux": "static-7.70",
  "redux": "static-4.16",
  "bend-plugin-trellis-migration": "static-1.3379",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3265",
  "quartz-webpack": "static-1.3212",
  "bend-plugin-quartz-routing": "static-1.66",
  "fast-json-stable-stringify": "static-1.4",
  "graphql": "static-1.81",
  "customer-data-objects": "static-1.7634",
  "frontend-preferences-client": "static-1.7901",
  "laboratory-lib": "static-3.7131",
  "onboarding-scopes": "static-1.6434",
  "ui-addon-opt": "static-4.8342",
  "HeadJS": "static-2.747",
  "hs-test-utils-bend-plugin": "static-1.3097",
  "msw": "static-1.39",
  "testing-library": "static-1.151",
  "hs-locale-management": "static-1.61",
  "ts-schema": "static-1.4054",
  "webpack-env": "static-1.54",
  "content-assistance-lib": "static-1.7704",
  "cssUtils": "static-1.783",
  "customer-data-ui-utilities": "static-1.9798",
  "HubStyle": "static-2.11745",
  "knowledge-content-types": "static-1.8483",
  "PatternValidationJS": "static-1.437",
  "quartz-i18n": "static-1.663",
  "react-input-autosize": "static-2.17",
  "StyleGuideUI": "static-3.486",
  "ui-addon-emoji-picker": "static-1.9859",
  "ui-addon-i18n": "static-1.11122",
  "ui-business-units-lib": "static-1.9021",
  "ui-shepherd-react": "static-3.10126",
  "video-components-external": "static-1.11171",
  "i18n-data": "static-1.220",
  "moment-timezone": "static-5.82",
  "jasmine": "static-4.4298",
  "commerce-tours-lib": "static-1.6035",
  "customer-data-properties": "static-1.51436",
  "getting-started-shared-tasks": "static-1.18417",
  "growth-onboarding-reliability": "static-1.5055",
  "onboarding-tours": "static-1.16540",
  "reference-resolvers-lite": "static-1.8067",
  "sales-checkout-service-client": "static-1.3611",
  "ui-addon-iframeable": "static-1.9029",
  "user-context": "static-1.5074",
  "dispatcher": "static-1.135",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.828",
  "hubspotter-http": "static-1.4628",
  "icons": "static-2.644",
  "mobile-manifest-mixins": "static-1.521",
  "module-federation": "static-1.22",
  "quartz-auth": "static-1.663",
  "quartz-head": "static-1.653",
  "quartz-test": "static-1.663",
  "quartz-tracking": "static-1.367",
  "ui-fonts": "static-1.699",
  "usage-tracker-container": "static-1.7307",
  "csstype": "static-1.50",
  "hs-story-utils": "static-1.9400",
  "data-token-picker": "static-1.16352",
  "FileManagerLib": "static-1.39174",
  "property-translator": "static-1.5374",
  "atom": "static-1.5043",
  "merchandise-lib": "static-1.263",
  "purchase-motions-components": "static-1.5829",
  "salesImages": "static-1.524",
  "SharedI18nStrings": "static-1.182",
  "foundations-components-test-utils": "static-1.5352",
  "react-select-plus": "static-1.104",
  "react-virtualized": "static-2.98",
  "ui-images": "static-2.1143",
  "bend-plugin-foundations-components": "static-1.4138",
  "floating-ui": "static-1.55",
  "react-aria": "static-1.65",
  "react-create-root-preference": "static-1.13",
  "trellis-assets": "static-1.1773",
  "bend-plugin-foundations-theming": "static-1.2873",
  "foundations-theming-base": "static-1.3375",
  "stylex": "static-1.32",
  "interframe": "static-3.4732",
  "js-cookie": "static-1.18",
  "usage-tracker-multi": "static-1.5731",
  "history": "static-4.47",
  "react-router-dom": "static-5.26",
  "web-vitals": "static-1.4",
  "bend-plugin-chirp-manifest": "static-1.34",
  "chirp-fetch": "static-1.1859",
  "autolinker": "static-3.11",
  "sanitize": "static-1.4447",
  "react-flip-move": "static-1.69",
  "bender-build-tools": "static-1.3160",
  "inbound-db-properties-service-client": "static-1.3819",
  "superstore": "static-1.4737",
  "feedback-loader": "static-1.29239",
  "ai-components-ui-library": "static-1.8859",
  "ui-addon-video-player": "static-1.8672",
  "ui-coaching-tips": "static-1.28462",
  "sassPrefix": "static-1.155",
  "react-dnd-compat": "static-1.4592",
  "react-immutable-proptypes": "static-2.8",
  "react-immutable-render-mixin": "static-1.9",
  "avatar-components": "static-1.2470",
  "redux-thunk": "static-2.43",
  "reference-resolvers": "static-1.8141",
  "reselect": "static-2.16",
  "apollo-link-hub-http": "static-2.4621",
  "content-media-composition-data-lib": "static-1.12157",
  "content-media-compositions": "static-2.16164",
  "idb-keyval": "static-1.43",
  "immer": "static-1.33",
  "immerable": "static-1.4126",
  "magpie-lib": "static-1.5537",
  "magpie-types": "static-1.4997",
  "media-bridge-lib": "static-1.18872",
  "video-data-lib": "static-1.34829",
  "commerce-products-lib": "static-1.9441",
  "crm-message-bus": "static-1.42907",
  "growth-data-modal": "static-1.5380",
  "hubspot-apollo-client": "static-1.4849",
  "onboarding-tours-client": "static-1.4754",
  "calling-global-api": "static-1.64411",
  "calling-internal-common": "static-1.31275",
  "calling-lifecycle-internal": "static-1.65793",
  "calling-lifecycle-messages": "static-1.58087",
  "conditional-properties-service-client": "static-1.3773",
  "crm-links": "static-1.6257",
  "customer-data-objects-ui-components": "static-1.12997",
  "customer-data-properties-shared-msw-handlers": "static-1.9214",
  "customer-data-property-utils": "static-1.8057",
  "external-options-client-types": "static-1.4134",
  "file-manager-components": "static-1.23534",
  "framework-data-schema-resolvers": "static-1.6853",
  "google-libphonenumber": "static-1.37",
  "hs-resources": "static-1.124",
  "inbound-db-meta-service-client": "static-1.3566",
  "inbounddb-objects-service-types": "static-1.4199",
  "meetings-icalendar-utils-lib": "static-1.604",
  "multi-currency-client-types": "static-1.3667",
  "object-builder-ui-client": "static-1.48631",
  "pipeline-validation-client-types": "static-1.3941",
  "property-value-citations": "static-1.2050",
  "pulse": "static-1.537",
  "smart-property-lib": "static-1.6767",
  "tiered-pricing": "static-1.1135",
  "ui-addon-form-validation": "static-1.10962",
  "growth-onboarding-confetti": "static-1.3039",
  "growth-onboarding-next-action-utils": "static-1.1832",
  "navigation-components": "static-1.17936",
  "onboarding-tours-utils": "static-1.606",
  "ui-shepherd-tracker": "static-1.7507",
  "ui-universal-auth": "static-1.8942",
  "batch-promise": "static-1.1513",
  "navigation-messaging": "static-1.7263",
  "getting-started-shared-tasks-store": "static-1.17535",
  "hubspotter-http-shared-msw-handlers": "static-1.9885",
  "usage-tracker-session-replay": "static-1.5003",
  "audio-components": "static-1.5869",
  "FileManagerCore": "static-1.39033",
  "FileManagerImages": "static-1.36685",
  "video-components": "static-1.13174",
  "foundations-components-legacy": "static-1.894",
  "purchase-motions-api": "static-1.5832",
  "self-service-api": "static-1.10217",
  "signup-constants": "static-1.18787",
  "signup-ui-url-generator": "static-2.8012",
  "trials-service-types": "static-1.3875",
  "usage-tracker-public": "static-1.7128",
  "chatspot-core": "static-1.21142",
  "ContentUtils": "static-1.68269",
  "copilot-toolkit": "static-1.11054",
  "growth-onboarding-feedback-components": "static-1.6554",
  "reactive-lib": "static-1.694",
  "simple-logging-lib": "static-1.3021",
  "commerce-permissions": "static-1.739",
  "customer-data-tracking": "static-1.6857",
  "products-iframe-lib": "static-1.7845",
  "products-ui-components-shared-msw-handlers": "static-1.10269",
  "onboarding-data-sync-lib": "static-1.1909",
  "hubspot-apollo-cache": "static-1.308",
  "calling-error-reporting": "static-1.31281",
  "shared-worker-versioning": "static-1.11010",
  "calling-usage-tracker": "static-1.6515",
  "voice-sms-access-library": "static-1.855",
  "conversations-skeleton-state": "static-1.7220",
  "location-customization-utils-lib": "static-1.9159",
  "crm-pipelines-api-client-types": "static-1.4118",
  "framework-builder-read-service-client": "static-1.3985",
  "framework-data-schema-quick-fetch": "static-1.6758",
  "persist-promise": "static-1.3670",
  "bend-plugin-pulse": "static-1.40",
  "directed-graph": "static-1.907",
  "event-emitter": "static-1.920",
  "fast-json-patch": "static-1.62",
  "data-agent-kit": "static-1.145",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9970",
  "fsm": "static-1.3703",
  "policy-lib": "static-1.6748",
  "react-tinymce": "static-1.55152",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10033",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.54278",
  "tinymce-plugins": "static-1.57392",
  "tinymce-themes": "static-1.56248",
  "growth-onboarding-next-action-components": "static-1.1860",
  "user-context-client": "static-1.4584",
  "nest": "static-1.197",
  "unified-auth-core-lib": "static-1.737",
  "amplitude-session-replay-browser": "static-1.59",
  "cropperjs": "static-1.10",
  "redux-toolkit": "static-1.7",
  "urlinator": "static-1.4505",
  "video-embed": "static-1.35663",
  "content-icons-ui": "static-1.2217",
  "social-insights-client-types": "static-1.22006",
  "markdown-it": "static-1.6",
  "cms-field-types": "static-1.4784",
  "integrations-lib": "static-1.16020",
  "underscore": "static-1.8",
  "sales-views-client-types": "static-1.4236",
  "InboxConnectUtils": "static-4.14727",
  "calling-orchestration-schema": "static-1.35632",
  "crm-record-cards-service-types": "static-1.3584",
  "highcharts": "static-8.103",
  "trellis-story-utils": "static-1.4488",
  "storybook-react": "static-1.32",
  "hub-http-contrib": "static-1.3011",
  "tinymce-data": "static-1.40363",
  "ui-addon-sales-email": "static-1.5182",
  "codemirror": "static-5.94",
  "layout-dnd-components": "static-1.12386",
  "layout-dnd-utils": "static-1.11361",
  "react-codemirror": "static-1.10597",
  "ui-brand-identity-lib": "static-1.15138",
  "NamespacedHubStyle": "static-2.9037",
  "outpost": "static-1.4158",
  "flux-actions": "static-1.331",
  "integrations-error-boundary-lib": "static-1.13435",
  "integrations-tracking-lib": "static-1.5571",
  "native-integrations-shared-strings": "static-1.7754",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10342",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.456",
  "diff-match-patch": "static-1.7",
  "ContentData": "static-1.68344",
  "layout-data-lib": "static-1.9686",
  "browser-eslint": "static-2.57",
  "universal-page-editor-lib": "static-1.2985",
  "google-sheets-integration-lib": "static-1.144",
  "microsoft-drive-integration-lib": "static-1.261",
  "advanced-menus-core": "static-1.15083",
  "advanced-menus-lib": "static-1.12029",
  "ExportDialog": "static-6.10365",
  "ui-memberships-settings-lib": "static-1.33960",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15082",
  "simple-menus-lib": "static-1.16599"
},
  depPathPrefixes: {
  "customer-portal-app": "/customer-portal-app/static-1.2215",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "client-types": "/client-types/static-1.466",
  "data-fetching-client": "/data-fetching-client/static-1.9644",
  "emoji-mart": "/emoji-mart/static-3.4",
  "enviro": "/enviro/static-4.428",
  "growth-payments-core": "/growth-payments-core/static-1.25284",
  "head-dlb": "/head-dlb/static-1.4938",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.5566",
  "hs-test-utils": "/hs-test-utils/static-1.7986",
  "hub-http": "/hub-http/static-1.6194",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9887",
  "hubspot-dlb": "/hubspot-dlb/static-2.1832",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18157",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4049",
  "HubStyleTokens": "/HubStyleTokens/static-2.11437",
  "I18n": "/I18n/static-7.1615",
  "immutable": "/immutable/static-2.77",
  "jasmine-runner": "/jasmine-runner/static-1.6439",
  "payment-link-components": "/payment-link-components/static-1.23448",
  "prosemirror": "/prosemirror/static-1.13",
  "quartz": "/quartz/static-1.6988",
  "quartz-core": "/quartz-core/static-1.6207",
  "react": "/react/static-7.185",
  "react-colorpicker": "/react-colorpicker/static-2.10182",
  "react-dlb": "/react-dlb/static-1.78",
  "react-utils": "/react-utils/static-2.5320",
  "rich-text-lib": "/rich-text-lib/static-1.19776",
  "transmute": "/transmute/static-2.85",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17943",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.5575",
  "UIComponents": "/UIComponents/static-3.8384",
  "foundations-assets": "/foundations-assets/static-1.4835",
  "foundations-components": "/foundations-components/static-1.7869",
  "foundations-theming": "/foundations-theming/static-1.4390",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2106",
  "framer-motion": "/framer-motion/static-1.71",
  "metrics-js": "/metrics-js/static-1.9542",
  "PortalIdParser": "/PortalIdParser/static-2.388",
  "portals-platform-lib": "/portals-platform-lib/static-1.852",
  "quartz-config": "/quartz-config/static-1.766",
  "quartz-routing": "/quartz-routing/static-1.418",
  "quick-fetch": "/quick-fetch/static-1.3892",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-dom": "/react-dom/static-7.85",
  "react-rhumb": "/react-rhumb/static-1.16641",
  "rpc-client-utils": "/rpc-client-utils/static-1.4624",
  "sanitize-text": "/sanitize-text/static-1.8114",
  "styled-components": "/styled-components/static-2.88",
  "tanstack-table": "/tanstack-table/static-1.54",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4740",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9516",
  "usage-tracker": "/usage-tracker/static-1.7317",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5734",
  "usage-tracker-core": "/usage-tracker-core/static-1.7167",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5489",
  "raven": "/raven/static-3.5829",
  "raven-hubspot": "/raven-hubspot/static-1.6136",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "react-redux": "/react-redux/static-7.70",
  "redux": "/redux/static-4.16",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3379",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3265",
  "quartz-webpack": "/quartz-webpack/static-1.3212",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.66",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "graphql": "/graphql/static-1.81",
  "customer-data-objects": "/customer-data-objects/static-1.7634",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7901",
  "laboratory-lib": "/laboratory-lib/static-3.7131",
  "onboarding-scopes": "/onboarding-scopes/static-1.6434",
  "ui-addon-opt": "/ui-addon-opt/static-4.8342",
  "HeadJS": "/HeadJS/static-2.747",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3097",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.151",
  "hs-locale-management": "/hs-locale-management/static-1.61",
  "ts-schema": "/ts-schema/static-1.4054",
  "webpack-env": "/webpack-env/static-1.54",
  "content-assistance-lib": "/content-assistance-lib/static-1.7704",
  "cssUtils": "/cssUtils/static-1.783",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9798",
  "HubStyle": "/HubStyle/static-2.11745",
  "knowledge-content-types": "/knowledge-content-types/static-1.8483",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "quartz-i18n": "/quartz-i18n/static-1.663",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "StyleGuideUI": "/StyleGuideUI/static-3.486",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9859",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11122",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9021",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10126",
  "video-components-external": "/video-components-external/static-1.11171",
  "i18n-data": "/i18n-data/static-1.220",
  "moment-timezone": "/moment-timezone/static-5.82",
  "jasmine": "/jasmine/static-4.4298",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6035",
  "customer-data-properties": "/customer-data-properties/static-1.51436",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18417",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5055",
  "onboarding-tours": "/onboarding-tours/static-1.16540",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8067",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3611",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9029",
  "user-context": "/user-context/static-1.5074",
  "dispatcher": "/dispatcher/static-1.135",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.828",
  "hubspotter-http": "/hubspotter-http/static-1.4628",
  "icons": "/icons/static-2.644",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.521",
  "module-federation": "/module-federation/static-1.22",
  "quartz-auth": "/quartz-auth/static-1.663",
  "quartz-head": "/quartz-head/static-1.653",
  "quartz-test": "/quartz-test/static-1.663",
  "quartz-tracking": "/quartz-tracking/static-1.367",
  "ui-fonts": "/ui-fonts/static-1.699",
  "usage-tracker-container": "/usage-tracker-container/static-1.7307",
  "csstype": "/csstype/static-1.50",
  "hs-story-utils": "/hs-story-utils/static-1.9400",
  "data-token-picker": "/data-token-picker/static-1.16352",
  "FileManagerLib": "/FileManagerLib/static-1.39174",
  "property-translator": "/property-translator/static-1.5374",
  "atom": "/atom/static-1.5043",
  "merchandise-lib": "/merchandise-lib/static-1.263",
  "purchase-motions-components": "/purchase-motions-components/static-1.5829",
  "salesImages": "/salesImages/static-1.524",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5352",
  "react-select-plus": "/react-select-plus/static-1.104",
  "react-virtualized": "/react-virtualized/static-2.98",
  "ui-images": "/ui-images/static-2.1143",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4138",
  "floating-ui": "/floating-ui/static-1.55",
  "react-aria": "/react-aria/static-1.65",
  "react-create-root-preference": "/react-create-root-preference/static-1.13",
  "trellis-assets": "/trellis-assets/static-1.1773",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2873",
  "foundations-theming-base": "/foundations-theming-base/static-1.3375",
  "stylex": "/stylex/static-1.32",
  "interframe": "/interframe/static-3.4732",
  "js-cookie": "/js-cookie/static-1.18",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5731",
  "history": "/history/static-4.47",
  "react-router-dom": "/react-router-dom/static-5.26",
  "web-vitals": "/web-vitals/static-1.4",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.34",
  "chirp-fetch": "/chirp-fetch/static-1.1859",
  "autolinker": "/autolinker/static-3.11",
  "sanitize": "/sanitize/static-1.4447",
  "react-flip-move": "/react-flip-move/static-1.69",
  "bender-build-tools": "/bender-build-tools/static-1.3160",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3819",
  "superstore": "/superstore/static-1.4737",
  "feedback-loader": "/feedback-loader/static-1.29239",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8859",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8672",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28462",
  "sassPrefix": "/sassPrefix/static-1.155",
  "react-dnd-compat": "/react-dnd-compat/static-1.4592",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "avatar-components": "/avatar-components/static-1.2470",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reference-resolvers": "/reference-resolvers/static-1.8141",
  "reselect": "/reselect/static-2.16",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4621",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12157",
  "content-media-compositions": "/content-media-compositions/static-2.16164",
  "idb-keyval": "/idb-keyval/static-1.43",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4126",
  "magpie-lib": "/magpie-lib/static-1.5537",
  "magpie-types": "/magpie-types/static-1.4997",
  "media-bridge-lib": "/media-bridge-lib/static-1.18872",
  "video-data-lib": "/video-data-lib/static-1.34829",
  "commerce-products-lib": "/commerce-products-lib/static-1.9441",
  "crm-message-bus": "/crm-message-bus/static-1.42907",
  "growth-data-modal": "/growth-data-modal/static-1.5380",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4849",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4754",
  "calling-global-api": "/calling-global-api/static-1.64411",
  "calling-internal-common": "/calling-internal-common/static-1.31275",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65793",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58087",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3773",
  "crm-links": "/crm-links/static-1.6257",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12997",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9214",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8057",
  "external-options-client-types": "/external-options-client-types/static-1.4134",
  "file-manager-components": "/file-manager-components/static-1.23534",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6853",
  "google-libphonenumber": "/google-libphonenumber/static-1.37",
  "hs-resources": "/hs-resources/static-1.124",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3566",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4199",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.604",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3667",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48631",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3941",
  "property-value-citations": "/property-value-citations/static-1.2050",
  "pulse": "/pulse/static-1.537",
  "smart-property-lib": "/smart-property-lib/static-1.6767",
  "tiered-pricing": "/tiered-pricing/static-1.1135",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10962",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3039",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1832",
  "navigation-components": "/navigation-components/static-1.17936",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.606",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7507",
  "ui-universal-auth": "/ui-universal-auth/static-1.8942",
  "batch-promise": "/batch-promise/static-1.1513",
  "navigation-messaging": "/navigation-messaging/static-1.7263",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17535",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9885",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5003",
  "audio-components": "/audio-components/static-1.5869",
  "FileManagerCore": "/FileManagerCore/static-1.39033",
  "FileManagerImages": "/FileManagerImages/static-1.36685",
  "video-components": "/video-components/static-1.13174",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.894",
  "purchase-motions-api": "/purchase-motions-api/static-1.5832",
  "self-service-api": "/self-service-api/static-1.10217",
  "signup-constants": "/signup-constants/static-1.18787",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8012",
  "trials-service-types": "/trials-service-types/static-1.3875",
  "usage-tracker-public": "/usage-tracker-public/static-1.7128",
  "chatspot-core": "/chatspot-core/static-1.21142",
  "ContentUtils": "/ContentUtils/static-1.68269",
  "copilot-toolkit": "/copilot-toolkit/static-1.11054",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6554",
  "reactive-lib": "/reactive-lib/static-1.694",
  "simple-logging-lib": "/simple-logging-lib/static-1.3021",
  "commerce-permissions": "/commerce-permissions/static-1.739",
  "customer-data-tracking": "/customer-data-tracking/static-1.6857",
  "products-iframe-lib": "/products-iframe-lib/static-1.7845",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10269",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.1909",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.308",
  "calling-error-reporting": "/calling-error-reporting/static-1.31281",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11010",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6515",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.855",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7220",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9159",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4118",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3985",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6758",
  "persist-promise": "/persist-promise/static-1.3670",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.40",
  "directed-graph": "/directed-graph/static-1.907",
  "event-emitter": "/event-emitter/static-1.920",
  "fast-json-patch": "/fast-json-patch/static-1.62",
  "data-agent-kit": "/data-agent-kit/static-1.145",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9970",
  "fsm": "/fsm/static-1.3703",
  "policy-lib": "/policy-lib/static-1.6748",
  "react-tinymce": "/react-tinymce/static-1.55152",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10033",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.54278",
  "tinymce-plugins": "/tinymce-plugins/static-1.57392",
  "tinymce-themes": "/tinymce-themes/static-1.56248",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.1860",
  "user-context-client": "/user-context-client/static-1.4584",
  "nest": "/nest/static-1.197",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.737",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.59",
  "cropperjs": "/cropperjs/static-1.10",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "urlinator": "/urlinator/static-1.4505",
  "video-embed": "/video-embed/static-1.35663",
  "content-icons-ui": "/content-icons-ui/static-1.2217",
  "social-insights-client-types": "/social-insights-client-types/static-1.22006",
  "markdown-it": "/markdown-it/static-1.6",
  "cms-field-types": "/cms-field-types/static-1.4784",
  "integrations-lib": "/integrations-lib/static-1.16020",
  "underscore": "/underscore/static-1.8",
  "sales-views-client-types": "/sales-views-client-types/static-1.4236",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.14727",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35632",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3584",
  "highcharts": "/highcharts/static-8.103",
  "trellis-story-utils": "/trellis-story-utils/static-1.4488",
  "storybook-react": "/storybook-react/static-1.32",
  "hub-http-contrib": "/hub-http-contrib/static-1.3011",
  "tinymce-data": "/tinymce-data/static-1.40363",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5182",
  "codemirror": "/codemirror/static-5.94",
  "layout-dnd-components": "/layout-dnd-components/static-1.12386",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11361",
  "react-codemirror": "/react-codemirror/static-1.10597",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15138",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9037",
  "outpost": "/outpost/static-1.4158",
  "flux-actions": "/flux-actions/static-1.331",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13435",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5571",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7754",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10342",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.456",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ContentData": "/ContentData/static-1.68344",
  "layout-data-lib": "/layout-data-lib/static-1.9686",
  "browser-eslint": "/browser-eslint/static-2.57",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2985",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.144",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.261",
  "advanced-menus-core": "/advanced-menus-core/static-1.15083",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12029",
  "ExportDialog": "/ExportDialog/static-6.10365",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33960",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15082",
  "simple-menus-lib": "/simple-menus-lib/static-1.16599"
}
};
